import { Box } from "@mui/material";
import NewHistoryModel from "./NewHistoryModel";
import { useMemo } from "react";

function HistoryModuleScreen() {
    const searchParams = new URLSearchParams(window.location.search);
    const tableName = searchParams.get('tableName');
    const id = searchParams.get('id');
    const breadCrumb = searchParams.get('breadCrumb');
    const where = useMemo(() => [
        {
            field: 'TableName',
            operator: 'contains',
            type: 'string',
            value: tableName
        },
        {
            field: 'PrimaryKey',
            operator: 'contains',
            type: 'string',
            value: id
        }
    ], [tableName, id]);
    // Remove the breadcrumb for 'null' string case
    const titleStr = breadCrumb !== 'null' ? `History > ${breadCrumb}` : 'History';
    return (
        <Box>
            <NewHistoryModel.Grid baseFilters={where} title={titleStr} />
        </Box>
    );
}

export default HistoryModuleScreen;